import React from "react";
import Input from "../input/input";
let self;

export class TimeLineForm extends React.Component<any, any> {
    timeLineFormForAPI = this.props.timeLineFormForAPI
    defaultForm = this.props.defaultForm
    constructor(props: any) {
        super(props);
        self = this;
        // this.send = this.send.bind(this);
        // if(props.timeLineType === Constants.timeLineEducationType) {
        //     this.timeLineFormForAPI = { name: '', designation: '', acedomicYear: '' };
        //     this.defaultForm = {name: '', designation: '', startYear:'', endYear:''}
        // } else {
        //     this.timeLineFormForAPI = { name: '', cources: '', acedomicYear: '', grade: '' };
        //     this.defaultForm = { name: '', cources: '', startYear:'', endYear:'', grade: '' };
        // }
        this.state = { timeLineFormForAPI: this.timeLineFormForAPI, noOfTimeline: 0, timeLineForm: this.defaultForm,  }

    }

    send(event, isNext) {
        event.preventDefault();
        const projectData = {
            ...this.state.timeLineForm,
            acedomicYear:`${this.state.timeLineForm.startYear} To ${this.state.timeLineForm.endYear}`
        }
        self.props.onTimeLineAdded(projectData, isNext)
    }

    onInputChange(data, field) {
        self.setState((prevState) => ({
            timeLineForm: { ...prevState.timeLineForm, [field]: data }
        }))
    }
    // onNoOfTechnologiesChange(data, field) {
    //     self.setState({ noOfTechnologies: data });
    //     console.log(self.state)
    // }

    // onTechnologyChanges(data, field) {
    //     self.setState((prevState) => ({
    //         technologies: { ...prevState.technologies, [field]: data }
    //     }))
    // }

    render(): React.ReactNode {
        return (
            <div className="form__wrapper">
                <h4>Enter TimeLine for {this.props.timeLineNo}</h4>
                <form className="form__item">
                    {/* <Input placeHolder='Enter Timeline Name' type='text' key={1} value="" maxLength="100" minLength="1" name="name" onInputChange={this.onInputChange}></Input>
                    <Input placeHolder='Enter Timeline Designation' type='text' key={2} value="" maxLength="100" minLength="1" name="designation" onInputChange={this.onInputChange}></Input>
                    <Input placeHolder='Enter Timeline Start Year' type='month' key={3} value="" maxLength="100" minLength="1" name="startYear" onInputChange={this.onInputChange}></Input>
                    <Input placeHolder='Enter Timeline End Year' type='month' key={4} value="" maxLength="100" minLength="1" name="endYear" onInputChange={this.onInputChange}></Input> */}
                  {  
                    Object.keys(this.props.defaultForm).map((infoForm: any, index: number) => {
                                    return (
                                <Input placeHolder={`Enter ${infoForm} for ${this.props.timeLineNo}`} type={(infoForm=== 'startYear' || infoForm=== 'endYear') ? 'month':'text'} key={index} value='' maxLength="100" minLength="1" name={infoForm} onInputChange={this.onInputChange}></Input>
                                    )
                                })
                        }
                        <>
                        <button className="app-btn" onClick={(e)=> this.send(e,false)}>Done?</button>
                        <button className="app-btn" onClick={(e)=> this.send(e,true)}>Add more</button>
                        </>
                </form>
            </div>
        )
    }
}

export default TimeLineForm;